{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Plakken",
    "pasteAsPlaintext": "Plakken als platte tekst",
    "pasteCharts": "Grafieken plakken",
    "chartType_bar": "Staafdiagram",
    "chartType_line": "Lijndiagram",
    "chartType_radar": "Spinnenweb diagram",
    "chartType_plaintext": "Tekst zonder opmaak",
    "selectAll": "Alles selecteren",
    "multiSelect": "Voeg element toe aan selectie",
    "moveCanvas": "Canvas verplaatsen",
    "cut": "Knip",
    "copy": "Kopiëren",
    "copyAsPng": "Kopieer als PNG",
    "copyAsSvg": "Kopieer naar klembord als SVG",
    "copyText": "Kopieer naar klembord als tekst",
    "copySource": "Bron kopiëren naar klembord",
    "convertToCode": "Zet om naar code",
    "bringForward": "Breng naar voren",
    "sendToBack": "Stuur naar achtergrond",
    "bringToFront": "Breng naar voorgrond",
    "sendBackward": "Breng naar achter",
    "delete": "Verwijderen",
    "copyStyles": "Kopieer opmaak",
    "pasteStyles": "Plak opmaak",
    "stroke": "Lijn",
    "changeStroke": "Verander lijn kleur",
    "background": "Achtergrond",
    "changeBackground": "Verander achtergrond kleur",
    "fill": "Invulling",
    "strokeWidth": "Lijnbreedte",
    "strokeStyle": "Lijnstijl",
    "strokeStyle_solid": "Ononderbroken",
    "strokeStyle_dashed": "Gestreept",
    "strokeStyle_dotted": "Gestippeld",
    "sloppiness": "Slordigheid",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Doorzichtigheid",
    "textAlign": "Uitlijning",
    "edges": "Randen",
    "sharp": "Hoekig",
    "round": "Rond",
    "arrowheads": "Pijlpunten",
    "arrowhead_none": "Geen",
    "arrowhead_arrow": "Pijl",
    "arrowhead_bar": "Balk",
    "arrowhead_circle": "Rond",
    "arrowhead_circle_outline": "Rond (omtrek)",
    "arrowhead_triangle": "Driehoek",
    "arrowhead_triangle_outline": "Driehoek (omtrek)",
    "arrowhead_diamond": "Diamant",
    "arrowhead_diamond_outline": "Diamant (omtrek)",
    "arrowhead_crowfoot_many": "Kraaienpoot (veel)",
    "arrowhead_crowfoot_one": "Kraaienpoot (enkel)",
    "arrowhead_crowfoot_one_or_many": "Kraaienpoot (enkel of veel)",
    "arrowhead_cardinality_one": "Kardinaliteit (één)",
    "arrowhead_cardinality_many": "Kardinaliteit (Meerdere)",
    "arrowhead_cardinality_one_or_many": "Kardinaliteit (één of meerdere)",
    "arrowhead_cardinality_exactly_one": "Kardinaliteit (Precies één)",
    "arrowhead_cardinality_zero_or_one": "Kardinaliteit (nul of één)",
    "arrowhead_cardinality_zero_or_many": "Kardinaliteit (nul of meerdere)",
    "more_options": "Meer opties",
    "cardinality": "Kardinaliteit",
    "arrowtypes": "Pijl type",
    "arrowtype_sharp": "Scherpe pijl",
    "arrowtype_round": "Gebogen pijl",
    "arrowtype_elbowed": "Hoek pijl",
    "fontSize": "Tekstgrootte",
    "fontFamily": "Lettertype",
    "addWatermark": "Voeg \"Gemaakt met Excalidraw\" toe",
    "handDrawn": "Handgetekend",
    "normal": "Normaal",
    "code": "Code",
    "small": "Klein",
    "medium": "Middel",
    "large": "Groot",
    "veryLarge": "Zeer groot",
    "solid": "Ingekleurd",
    "hachure": "Arcering",
    "zigzag": "Zigzag",
    "crossHatch": "Tweemaal gearceerd",
    "thin": "Dun",
    "bold": "Vet",
    "left": "Links",
    "center": "Midden",
    "right": "Rechts",
    "extraBold": "Zwaar",
    "architect": "Architect",
    "artist": "Artiest",
    "cartoonist": "Cartoonist",
    "fileTitle": "Bestandsnaam",
    "colorPicker": "Kleurenkiezer",
    "canvasColors": "Gebruikt op canvas",
    "canvasBackground": "Canvas achtergrond",
    "drawingCanvas": "Canvas",
    "clearCanvas": "Canvas legen",
    "layers": "Lagen",
    "actions": "Acties",
    "language": "Taal",
    "liveCollaboration": "Live Samenwerking...",
    "duplicateSelection": "Dupliceer",
    "untitled": "Naamloos",
    "name": "Naam",
    "yourName": "Jouw naam",
    "madeWithExcalidraw": "Gemaakt met Excalidraw",
    "group": "Groeperen",
    "ungroup": "Groep opheffen",
    "collaborators": "Deelnemers",
    "you": "",
    "toggleGrid": "Raster in-/uitschakelen",
    "loadingScene": "Scène laden…",
    "loadScene": "Laad scène van uit bestand",
    "align": "Uitlijnen",
    "alignTop": "Boven uitlijnen",
    "alignBottom": "Onder uitlijnen",
    "alignLeft": "Links uitlijnen",
    "alignRight": "Rechts uitlijnen",
    "centerVertically": "Verticaal Centreren",
    "centerHorizontally": "Horizontaal Centreren",
    "distributeHorizontally": "Horizontaal verspreiden",
    "distributeVertically": "Verticaal distribueren",
    "flipHorizontal": "Horizontaal spiegelen",
    "flipVertical": "Verticaal spiegelen",
    "viewMode": "Weergavemodus",
    "share": "Deel",
    "showStroke": "Toon lijn kleur kiezer",
    "showBackground": "Toon achtergrondkleur kiezer",
    "showFonts": "Lettertype kiezer weergeven",
    "toggleTheme": "Licht-/donkerthema in-/uitschakelen",
    "theme": "Thema",
    "decreaseFontSize": "Letters verkleinen",
    "increaseFontSize": "Letters vergroten",
    "unbindText": "Ontkoppel tekst",
    "bindText": "Koppel tekst aan de container",
    "createContainerFromText": "Tekst in een container laten doorlopen",
    "link": {
      "edit": "Wijzig link",
      "editEmbed": "Bewerken van insluitbare link",
      "create": "Link toevoegen",
      "label": "Link",
      "labelEmbed": "Link toevoegen & embedden",
      "empty": "Er is geen link ingesteld",
      "hint": "Typ of plak je link hier",
      "goToElement": "Ga naar doelelement"
    },
    "lineEditor": {
      "edit": "Bewerk regel",
      "editArrow": "Pijl bewerken"
    },
    "polygon": {
      "breakPolygon": "Breek veelhoek",
      "convertToPolygon": "Veranderen naar veelhoek"
    },
    "elementLock": {
      "lock": "Vergrendel",
      "unlock": "Ontgrendel",
      "lockAll": "Vergrendel alles",
      "unlockAll": "Ontgrendel alles"
    },
    "sidebarLock": "Zijbalk open houden",
    "selectAllElementsInFrame": "Selecteer alle elementen in het frame",
    "removeAllElementsFromFrame": "Verwijder alle elementen in het frame",
    "eyeDropper": "Kies kleur van canvas",
    "followUs": "Volg ons",
    "discordChat": "Discord chat",
    "zoomToFitViewport": "Zoom om in het venster te laten passen",
    "zoomToFitSelection": "Zoom om in selectie te laten passen",
    "zoomToFit": "Zoom om alle element te laten passen",
    "installPWA": "Installeer Excalidraw lokaal (PWA)",
    "autoResize": "Automatisch aanpassen van tekst inschakelen",
    "imageCropping": "Afbeelding bijsnijden",
    "unCroppedDimension": "Niet bijgesneden dimensie",
    "copyElementLink": "Kopieer link naar object",
    "linkToElement": "Link naar object",
    "wrapSelectionInFrame": "Selectie omslaan in frame",
    "tab": "Tab",
    "shapeSwitch": "Verander vorm",
    "preferences": "Voorkeuren",
    "preferences_toolLock": "Tool vergrendelen",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "Pijlverbinding",
    "midpointSnapping": "Vastklikken op middelpunt"
  },
  "elementLink": {
    "title": "Link naar object",
    "desc": "Klik op een vorm op canvas of plak een link.",
    "notFound": "Gekoppeld object is niet gevonden op canvas."
  },
  "search": {
    "title": "Zoek op canvas",
    "noMatch": "Geen overeenkomsten gevonden...",
    "singleResult": "resultaat",
    "multipleResults": "resultaten",
    "placeholder": "Zoek text op canvas...",
    "frames": "Frames",
    "texts": "Teksten"
  },
  "buttons": {
    "clearReset": "Canvas opnieuw instellen",
    "exportJSON": "Exporteren naar bestand",
    "exportImage": "Exporteer afbeelding...",
    "export": "Sla op...",
    "copyToClipboard": "Kopieer",
    "copyLink": "Link kopiëren",
    "save": "Opslaan naar huidige bestand",
    "saveAs": "Opslaan als",
    "load": "Open",
    "getShareableLink": "Maak een deelbare link",
    "close": "Sluiten",
    "selectLanguage": "Taal selecteren",
    "scrollBackToContent": "Scroll terug naar inhoud",
    "zoomIn": "Inzoomen",
    "zoomOut": "Uitzoomen",
    "resetZoom": "Zoom terugzetten",
    "menu": "Menu",
    "done": "Klaar",
    "edit": "Bewerken",
    "undo": "Ongedaan maken",
    "redo": "Herstel ongedaan maken",
    "createNewRoom": "Creëer live-samenwerkingssessie",
    "fullScreen": "Volledig scherm",
    "darkMode": "Donkere modus",
    "lightMode": "Lichte modus",
    "systemMode": "Systeemmodus",
    "zenMode": "Zen modus",
    "objectsSnapMode": "Uitlijnen op objecten",
    "exitZenMode": "Verlaat zen modus",
    "cancel": "Annuleren",
    "clear": "Wissen",
    "remove": "Verwijderen",
    "embed": "Embedden in-/uitschakelen",
    "submit": "Versturen",
    "confirm": "Bevestigen",
    "embeddableInteractionButton": "Klik voor interactie"
  },
  "alerts": {
    "clearReset": "Dit zal het hele canvas verwijderen. Weet je het zeker?",
    "couldNotCreateShareableLink": "Kon geen deelbare link aanmaken.",
    "couldNotCreateShareableLinkTooBig": "Kan geen deelbare link aanmaken: de scène is te groot",
    "couldNotLoadInvalidFile": "Kan ongeldig bestand niet laden",
    "importBackendFailed": "Importeren vanuit backend mislukt.",
    "cannotExportEmptyCanvas": "Kan geen leeg canvas exporteren.",
    "couldNotCopyToClipboard": "Kon niet naar klembord kopiëren.",
    "decryptFailed": "Kan gegevens niet decoderen.",
    "uploadedSecurly": "De upload is beveiligd met end-to-end encryptie, wat betekent dat de Excalidraw server en derden de inhoud niet kunnen lezen.",
    "loadSceneOverridePrompt": "Het inladen van een externe tekening zal je bestaande inhoud vervangen. Wil je verdergaan?",
    "collabStopOverridePrompt": "Wanneer de sessie wordt gestopt, overschrijft u de eerdere, lokaal opgeslagen tekening. Weet je het zeker?\n\n(Als je de lokale tekening wilt behouden, sluit je in plaats daarvan het browsertabblad)",
    "imageDoesNotContainScene": "Deze afbeelding lijkt geen scène gegevens te bevatten. Heb je scène embedding tijdens het exporteren ingeschakeld?",
    "cannotRestoreFromImage": "Scène kan niet worden hersteld vanuit dit afbeeldingsbestand",
    "invalidSceneUrl": "Kan scène niet importeren vanuit de opgegeven URL. Het is onjuist of bevat geen geldige Excalidraw JSON-gegevens.",
    "invalidEncryptionKey": "Encryptiesleutel moet 22 tekens zijn. Live samenwerking is uitgeschakeld.",
    "collabOfflineWarning": "Geen internetverbinding beschikbaar.\nJe wijzigingen worden niet opgeslagen!",
    "localStorageQuotaExceeded": "Limiet voor browser opslag overschreden. Wijzigingen worden niet opgeslagen."
  },
  "errors": {
    "unsupportedFileType": "Niet-ondersteund bestandstype.",
    "imageInsertError": "Afbeelding invoegen mislukt. Probeer het later opnieuw...",
    "fileTooBig": "Bestand is te groot. Maximale grootte is {{maxSize}}.",
    "svgImageInsertError": "Kon geen SVG-afbeelding invoegen. De SVG-opmaak ziet er niet geldig uit.",
    "failedToFetchImage": "Afbeeldingen ophalen mislukt.",
    "cannotResolveCollabServer": "Kan geen verbinding maken met de collab server. Herlaad de pagina en probeer het opnieuw.",
    "collabSaveFailed": "Kan niet opslaan in de backend database. Als de problemen blijven bestaan, moet u het bestand lokaal opslaan om ervoor te zorgen dat u uw werk niet verliest.",
    "collabSaveFailed_sizeExceeded": "Kan de backend database niet opslaan, het canvas lijkt te groot te zijn. U moet het bestand lokaal opslaan om ervoor te zorgen dat u uw werk niet verliest.",
    "imageToolNotSupported": "Afbeeldingen zijn uitgeschakeld.",
    "brave_measure_text_error": {
      "line1": "Het lijkt erop dat je de Brave browser gebruikt met de instelling <bold>Agressief vingerafdrukken blokkeren</bold> ingeschakeld.",
      "line2": "Dit kan leiden tot het breken van de <bold>Tekst Elementen</bold> in je tekening.",
      "line3": "We raden sterk aan om deze instelling uit te zetten. Je kan <link>deze stappen</link> volgen om te zien hoe.",
      "line4": "Als het uitschakelen van deze instelling het weergeven van tekstelementen niet oplost, open dan een <issueLink>issue</issueLink> op onze GitHub, of stuur ons een bericht op <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Plakken mislukt (kan niet van het systeem klembord lezen).",
    "asyncPasteFailedOnParse": "Kon niet plakken.",
    "copyToSystemClipboardFailed": "Kon niet naar klembord kopiëren."
  },
  "toolBar": {
    "selection": "Selectie",
    "lasso": "Lasso selectie",
    "image": "Voeg afbeelding in",
    "rectangle": "Rechthoek",
    "diamond": "Ruit",
    "ellipse": "Ovaal",
    "arrow": "Pijl",
    "line": "Lijn",
    "freedraw": "Teken",
    "text": "Tekst",
    "lock": "Geselecteerde tool actief houden na tekenen",
    "penMode": "Pen modus - Blokkeer aanraken",
    "link": "Link toevoegen / bijwerken voor een geselecteerde vorm",
    "eraser": "Gum",
    "frame": "Frame tool",
    "embeddable": "Web Embed",
    "laser": "Laseraanwijzer",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Hand (panning tool)",
    "extraTools": "Meer tools",
    "convertElementType": "Vorm type in-/uitschakelen"
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Rechthoek",
    "diamond": "Diamant",
    "ellipse": "Ovaal",
    "arrow": "Pijl",
    "line": "Lijn",
    "freedraw": "Los tekenen",
    "text": "Tekst",
    "image": "Afbeelding",
    "group": "Groep",
    "frame": "Kader",
    "embeddable": "Web Embed",
    "selection": "Selectie",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Canvasacties",
    "selectedShapeActions": "Acties van geselecteerde vorm",
    "shapes": "Vormen"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} om zoekopdracht te sluiten",
    "canvasPanning": "Om canvas te verplaatsen, houd {{shortcut_1}} of {{shortcut_2}} ingedrukt tijdens slepen, of gebruik de hand tool",
    "linearElement": "Klik om meerdere punten te starten, sleep voor één lijn",
    "arrowTool": "Klik om meerdere punten te starten, sleep naar een enkele lijn. Druk nogmaals op {{shortcut}} om het pijltype te wijzigen.",
    "arrowBindModifiers": "Houd {{shortcut_1}} ingedrukt om binding uit te schakelen of {{shortcut_2}} om op een vast punt te binden",
    "freeDraw": "Klik en sleep, laat los als je klaar bent",
    "text": "Tip: je kunt tekst toevoegen door ergens dubbel te klikken met de selectietool",
    "embeddable": "Klink-sleep om een website-insluiting te maken",
    "autoshape": "",
    "text_selected": "Dubbelklik of druk op {{shortcut}} om de tekst te bewerken",
    "text_editing": "Druk op {{shortcut_1}} of {{shortcut_2}} om het bewerken te voltooien",
    "linearElementMulti": "Klik op het laatste punt of druk op {{shortcut_1}} of {{shortcut_2}} om te voltooien",
    "lockAngle": "Je kan hoek beperken door {{shortcut}} ingedrukt te houden",
    "resize": "Je kunt de verhoudingen behouden door {{shortcut_1}} ingedrukt te houden tijdens het schalen,\nhoud {{shortcut_2}} ingedrukt om vanuit het midden te schalen",
    "resizeImage": "Je kunt vrij vergroten of verkleinen door {{shortcut_1}} ingedrukt te houden,\nhoud {{shortcut_2}} ingedrukt om vanuit het midden te schalen",
    "rotate": "Je kan hoeken beperken door {{shortcut}} ingedrukt te houden tijdens het draaien",
    "toggleArrowhead": "",
    "lineEditor_info": "Houd {{shortcut_1}} en Dubbelklik of druk op {{shortcut_2}} om punten te bewerken",
    "lineEditor_line_info": "Dubbelklik of druk op {{shortcut}} om punten te bewerken",
    "lineEditor_pointSelected": "Druk op {{shortcut_1}} om punt(en) te verwijderen,\n{{shortcut_2}} om te dupliceren, of sleep om te verplaatsen",
    "lineEditor_nothingSelected": "Selecteer een punt om te bewerken (houd {{shortcut_1}} ingedrukt om meerdere te selecteren),\nof houd {{shortcut_2}} ingedrukt en klik om nieuwe punten toe te voegen",
    "bindTextToElement": "{{shortcut}} om tekst toe te voegen",
    "createFlowchart": "{{shortcut}} voor het maken van een flowchart",
    "deepBoxSelect": "Houd {{shortcut}} ingedrukt om diep te selecteren, en om slepen te voorkomen",
    "eraserRevert": "Houd {{shortcut}} ingedrukt om de elementen die voor verwijdering zijn gemarkeerd te herstellen",
    "firefox_clipboard_write": "Deze functie kan waarschijnlijk worden ingeschakeld door de vlag \"dom.events.asyncClipboard.clipboardItem\" op \"true\" te zetten. Om de browser flags in Firefox te wijzigen, ga naar de pagina \"about:config\".",
    "disableSnapping": "Houd {{shortcut}} ingedrukt om uitlijnen uit te schakelen",
    "enterCropEditor": "Dubbelklik op de afbeelding of druk op {{shortcut}} om de afbeelding bij te snijden",
    "leaveCropEditor": "Klik buiten de afbeelding of druk op {{shortcut_1}} of {{shortcut_2}} om het bijsnijden te voltooien"
  },
  "canvasError": {
    "cannotShowPreview": "Kan voorbeeld niet tonen",
    "canvasTooBig": "Het canvas is mogelijk te groot.",
    "canvasTooBigTip": "Tip: beweeg de verste elementen iets dichter bij elkaar."
  },
  "errorSplash": {
    "headingMain": "Fout opgetreden. Probeer <button>de pagina opnieuw laden.</button>",
    "clearCanvasMessage": "Als herladen niet werkt, probeer <button>het canvas te wissen.</button>",
    "clearCanvasCaveat": " Dit zal leiden tot verlies van je werk ",
    "trackedToSentry": "De fout met ID {{eventId}} was gevolgd op ons systeem.",
    "openIssueMessage": "We waren voorzichtig om je scène-informatie niet in de fout toe te voegen. Als je scène niet privé is, overweeg dan alstublieft het opvolgen op onze <button>bugtracker.</button> Kopieer de informatie hieronder naar de GitHub issue.",
    "sceneContent": "Scène-inhoud:"
  },
  "shareDialog": {
    "or": "Of"
  },
  "roomDialog": {
    "desc_intro": "Nodig mensen uit om samen te werken aan je tekening.",
    "desc_privacy": "Geen zorgen, de sessie is end-to-end versleuteld en volledig privé. Niet eens onze server kan zien wat je tekent.",
    "button_startSession": "Start sessie",
    "button_stopSession": "Stop sessie",
    "desc_inProgressIntro": "De live-samenwerkingssessie is nu gestart.",
    "desc_shareLink": "Deel deze link met iedereen waarmee je wil samenwerken:",
    "desc_exitSession": "Het stoppen van de sessie zal je loskoppelen van de kamer, maar je kunt lokaal doorwerken met de scène.\nPas op: dit heeft geen invloed op andere mensen en dat zij nog steeds in staat zullen zijn om samen te werken aan hun versie.",
    "shareTitle": "Neem deel aan een live samenwerkingssessie op Excalidraw"
  },
  "errorDialog": {
    "title": "Fout"
  },
  "progressDialog": {
    "title": "Bezig met opslaan",
    "defaultMessage": "Voorbereiden om op te slaan..."
  },
  "exportDialog": {
    "disk_title": "Opslaan op schijf",
    "disk_details": "De scènegegevens exporteren naar een bestand waaruit u later kunt importeren.",
    "disk_button": "Opslaan naar bestand",
    "link_title": "Deelbare link",
    "link_details": "Exporteren als een alleen-lezen link.",
    "link_button": "Exporteer naar link",
    "excalidrawplus_description": "Sla de scène op in je Excalidraw+ werkruimte.",
    "excalidrawplus_button": "Exporteer",
    "excalidrawplus_exportError": "Kan op dit moment niet exporteren naar Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Lees onze blog",
    "click": "klik",
    "deepSelect": "Deep selecteer",
    "deepBoxSelect": "Diep selecteren binnen het kader en slepen voorkomen",
    "createFlowchart": "Maak een flowchart van een generiek element",
    "navigateFlowchart": "Navigeer naar een flowchart",
    "curvedArrow": "Gebogen pijl",
    "curvedLine": "Kromme lijn",
    "documentation": "Documentatie",
    "doubleClick": "dubbelklikken",
    "drag": "slepen",
    "editor": "Editor",
    "editLineArrowPoints": "Lijn/pijl punten bewerken",
    "editText": "Tekst bewerken / label toevoegen",
    "github": "Probleem gevonden? Verzenden",
    "howto": "Volg onze handleidingen",
    "or": "of",
    "preventBinding": "Pijlbinding voorkomen",
    "tools": "Tools",
    "shortcuts": "Sneltoetsen",
    "textFinish": "Voltooi het bewerken (teksteditor)",
    "textNewLine": "Nieuwe regel toevoegen (teksteditor)",
    "title": "Help",
    "view": "Weergave",
    "zoomToFit": "Zoom in op alle elementen",
    "zoomToSelection": "Inzoomen op selectie",
    "toggleElementLock": "Selectie vergrendelen/ontgrendelen",
    "movePageUpDown": "Pagina omhoog/omlaag",
    "movePageLeftRight": "Verplaats pagina links/rechts",
    "cropStart": "Afbeelding bijsnijden",
    "cropFinish": "Afbeelding bijsnijden voltooien"
  },
  "clearCanvasDialog": {
    "title": "Wis canvas"
  },
  "imageExportDialog": {
    "header": "Exporteer afbeelding",
    "label": {
      "withBackground": "Achtergrond",
      "onlySelected": "Alleen geselecteerd",
      "darkMode": "Donkere modus",
      "embedScene": "Scène embedden",
      "scale": "Schaal",
      "padding": "Padding"
    },
    "tooltip": {
      "embedScene": "Scènegegevens worden opgeslagen in het geëxporteerde PNG/SVG-bestand, zodat de scène hieruit kan worden hersteld.\nDit zal de geëxporteerde bestandsgrootte verhogen."
    },
    "title": {
      "exportToPng": "Exporteer naar PNG",
      "exportToSvg": "Exporteer naar SVG",
      "copyPngToClipboard": "Kopieer PNG naar klembord"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopieer naar klembord"
    }
  },
  "encrypted": {
    "tooltip": "Je tekeningen zijn beveiligd met end-to-end encryptie, dus Excalidraw's servers zullen nooit zien wat je tekent.",
    "link": "Blog post over end-to-end versleuteling in Excalidraw"
  },
  "stats": {
    "angle": "Hoek",
    "shapes": "Vormen",
    "height": "Hoogte",
    "scene": "Scene",
    "selected": "Geselecteerd",
    "storage": "Opslag",
    "fullTitle": "Canvas & Vorm eigenschappen",
    "title": "Eigenschappen",
    "generalStats": "Algemeen",
    "elementProperties": "Vorm eigenschappen",
    "total": "Totaal",
    "version": "Versie",
    "versionCopy": "Klik om te kopiëren",
    "versionNotAvailable": "Versie niet beschikbaar",
    "width": "Breedte"
  },
  "toast": {
    "copyStyles": "Stijlen gekopieerd.",
    "copyToClipboard": "Gekopieerd naar het klembord.",
    "copyToClipboardAsPng": "{{exportSelection}} naar klembord gekopieerd als PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} gekopieerd naar klembord als SVG\n({{exportColorScheme}})",
    "fileSaved": "Bestand opgeslagen.",
    "fileSavedToFilename": "Opgeslagen als {filename}",
    "canvas": "canvas",
    "selection": "selectie",
    "pasteAsSingleElement": "Gebruik {{shortcut}} om te plakken als een enkel element,\nof plak in een bestaande teksteditor",
    "unableToEmbed": "Het insluiten van deze URL is momenteel niet toegestaan. Zet een probleem op GitHub om de URL op de whitelist te zetten",
    "unrecognizedLinkFormat": "De link die u hebt ingesloten komt niet overeen met het verwachte formaat. Probeer de 'embed' string van de bronsite te plakken",
    "elementLinkCopied": "Link gekopieerd naar klembord"
  },
  "colors": {
    "transparent": "Transparant",
    "black": "Zwart",
    "white": "Wit",
    "red": "Rood",
    "pink": "Roze",
    "grape": "Druif",
    "violet": "Violet",
    "gray": "Grijs",
    "blue": "Blauw",
    "cyan": "Cyaan",
    "teal": "Groenblauw",
    "green": "Groen",
    "yellow": "Geel",
    "orange": "Oranje",
    "bronze": "Brons"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Je tekeningen worden bewaard in de opslag van je browser.",
      "center_heading_line2": "Browser opslag kan onverwacht gewist worden.",
      "center_heading_line3": "Sla je werk regelmatig op in een bestand om te voorkomen dat je het kwijtraakt.",
      "center_heading_plus": "Wil je in plaats daarvan naar Excalidraw+ gaan?",
      "menuHint": "Exporteren, voorkeuren en meer, ..."
    },
    "defaults": {
      "menuHint": "Exporteren, voorkeuren en meer...",
      "center_heading": "Diagrammen. Eenvoudig. Gemaakt.",
      "toolbarHint": "Kies een tool & begin met tekenen!",
      "helpHint": "Snelkoppelingen en hulp"
    }
  },
  "colorPicker": {
    "color": "Kleur",
    "mostUsedCustomColors": "Meest gebruikte aangepaste kleur",
    "colors": "Kleuren",
    "shades": "Tinten",
    "hexCode": "HEX-code",
    "noShades": "Geen tinten beschikbaar voor deze kleur",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exporteer als afbeelding",
        "button": "Exporteer als afbeelding",
        "description": "Exporteer de scènegegevens als een afbeelding die je later weer kunt importeren."
      },
      "saveToDisk": {
        "title": "Opslaan op schijf",
        "button": "Opslaan op schijf",
        "description": "Exporteer de scènegegevens als bestand die je later weer kunt importeren."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exporteer naar Excalidraw+",
        "description": "Sla de scène op in je Excalidraw+ werkruimte."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Laad vanuit bestand",
        "button": "Laad vanuit bestand",
        "description": "Het laden van een bestand zal <bold>je bestaande inhoud vervangen</bold>.<br></br>Je kunt eerst een back-up van je tekening maken via een van de onderstaande opties."
      },
      "shareableLink": {
        "title": "Laad vanuit link",
        "button": "Vervang mijn inhoud",
        "description": "Het laden van externe tekening zal <bold>je bestaande inhoud vervangen</bold>.<br></br>Je kunt eerst een back-up van je tekening maken via een van de onderstaande opties."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Snel Zoeken"
  },
  "fontList": {
    "badge": {
      "old": "oud"
    },
    "sceneFonts": "In deze scène",
    "availableFonts": "Beschikbare lettertypen",
    "empty": "Geen lettertypes gevonden"
  },
  "userList": {
    "empty": "Geen gebruikers gevonden",
    "hint": {
      "text": "Klik op de gebruiker om te volgen",
      "followStatus": "Je volgt momenteel deze gebruiker",
      "inCall": "Gebruiker is in een spraakoproep",
      "micMuted": "Microfoon van gebruiker is gedempt",
      "isSpeaking": "Gebruiker praat"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Optie",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "Shift",
    "spacebar": "Spatie",
    "delete": "Delete",
    "mmb": "Muiswiel"
  }
}
